<h2 mat-dialog-title>
  {{ 'igo.geo.draw.popupTitle' | translate }}
</h2>

@if (labelFlag() !== labelType.Custom) {
  <div mat-dialog-content class="geometry-type-toggle">
    <div class="button-toggle-container">
      <mat-button-toggle-group
        (change)="onLabelTypeChange($event.value)"
        [value]="customOrPredefined"
      >
        <mat-button-toggle [value]="labelType.Custom">
          {{ 'igo.geo.draw.labelType.custom' | translate }}
        </mat-button-toggle>
        <mat-button-toggle [value]="labelType.Predefined">
          {{ 'igo.geo.draw.labelType.predefined' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div>
      <p>
        {{ 'igo.geo.draw.builtInInstructions' | translate }}
      </p>
      @if (olGeometryType !== 'Polygon') {
        <mat-radio-group>
          @for (option of arrayBuiltInType; track option) {
            <mat-radio-button
              [value]="option.value"
              [disabled]="optionAvailable(option.value)"
              (change)="onLabelTypeChange($event.value)"
              [checked]="option.checked"
            >
              {{ getProperLengthLabel(option.value) }}
            </mat-radio-button>
          }
        </mat-radio-group>
      }
      @if (olGeometryType === 'Polygon') {
        @for (option of arrayBuiltInType; track option) {
          <mat-checkbox
            [value]="option.value"
            [disabled]="optionAvailable(option.value)"
            (change)="
              onLabelTypeChange($any($event.source.value), $event.checked)
            "
            [checked]="option.checked"
          >
            {{ getProperLengthLabel(option.value) }}
          </mat-checkbox>
        }
      }
      @if (labelFlag() === labelType.Coordinates) {
        <div class="fields-container">
          <mat-form-field class="readOnly-Input">
            <mat-label>(Latitude, Longitude)</mat-label>
            <input
              #input
              matInput
              placeholder="(Latitude, Longitude)"
              value="{{ currentCoordinates }}"
              readonly
            />
          </mat-form-field>
          <mat-form-field class="unit-field">
            <mat-select
              [value]="coordinatesMeasureUnit()"
              (selectionChange)="onChangeCoordinateUnit($event.value)"
            >
              @for (unit of allCoordinatesUnits; track unit) {
                <mat-option [value]="unit">
                  {{ unit }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (labelFlag() === labelType.Length || polygonCheck === 2) {
        <div class="fields-container">
          <mat-form-field class="readOnly-Input">
            <mat-label>{{ lengthLabelT }}</mat-label>
            <input
              #input
              matInput
              placeholder="{{ lengthLabelT }}"
              value="{{ currentLength }}"
              readonly
            />
          </mat-form-field>
          <mat-form-field class="unit-field">
            <mat-select
              [value]="lengthMeasureUnit()"
              (selectionChange)="onChangeLengthUnit($event.value)"
            >
              @for (unit of allLengthUnits; track unit) {
                <mat-option [value]="unit">
                  {{ getLengthUnitEnum(unit) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (labelFlag() === labelType.Area || polygonCheck === 2) {
        <div class="fields-container">
          <mat-form-field class="readOnly-Input">
            <mat-label>{{
              'igo.geo.draw.labelType.Area' | translate
            }}</mat-label>
            <input
              #input
              matInput
              placeholder="{{ 'igo.geo.draw.labelType.Area' | translate }}"
              value="{{ currentArea }}"
              readonly
            />
          </mat-form-field>
          <mat-form-field class="unit-field">
            <mat-select
              [value]="areaMeasureUnit()"
              (selectionChange)="onChangeAreaUnit($event.value)"
            >
              @for (unit of allAreaUnits; track unit) {
                <mat-option [value]="unit">
                  {{ getAreaUnitEnum(unit) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <button matButton="elevated" (click)="cancelDrawing()">
      {{ 'igo.geo.draw.cancel' | translate }}
    </button>
    <button matButton="elevated" color="primary" (click)="confirm()">
      {{ noLabelButton() }}
    </button>
  </div>
}

@if (labelFlag() === labelType.Custom) {
  <div mat-dialog-content class="geometry-type-toggle">
    <div class="button-toggle-container">
      <mat-button-toggle-group
        (change)="onLabelTypeChange($event.value)"
        [value]="customOrPredefined"
      >
        <mat-button-toggle [value]="labelType.Custom">
          {{ 'igo.geo.draw.labelType.custom' | translate }}
        </mat-button-toggle>
        <mat-button-toggle [value]="labelType.Predefined">
          {{ 'igo.geo.draw.labelType.predefined' | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <p>
      {{ 'igo.geo.draw.dialogInstruction' | translate }}
    </p>
    <mat-form-field class="input">
      <mat-label>{{ 'igo.geo.draw.dialogTitle' | translate }}</mat-label>
      <input
        #input
        matInput
        (select)="(true)"
        (input)="getLabelLength($any($event.target).value)"
        placeholder="{{ 'igo.geo.draw.dialogTitle' | translate }}"
        value="{{ currentLabel }}"
        cdkFocusInitial
      />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button matButton="elevated" (click)="cancelDrawing()">
      {{ 'igo.geo.draw.cancel' | translate }}
    </button>
    <button matButton="elevated" color="primary" (click)="confirm(input.value)">
      {{ noLabelButton() }}
    </button>
  </div>
}
